import StockForecast from '../../model/forecast-stock-data';

export default class AvailabilityStatusIcon {

  static readonly ASYNC_KEY = 'availabilityStatusIcon';

  /* eslint-disable max-len */
  private readonly DELIVERY_DATE_UNKNOWN_ICON = `<img width="18" height="18" src="${window.ACC.config.commonResourcePath}/images/icons/cross-circle-black.svg" alt=""/>`;
  private readonly PARTIAL_DELIVERY_ICON = `<img width="18" height="18" src="${window.ACC.config.commonResourcePath}/images/icons/alert-round-orange-bold.png" alt=""/>`;
  private readonly DELIVERY_DATE_KNOWN_ICON = `<img width="18" height="18" src="${window.ACC.config.commonResourcePath}/images/icons/check-circle-green.png" alt=""/>`;
  /* eslint-enable max-len */

  constructor(private readonly container: HTMLElement, private stockForecast: StockForecast[] = []) {
    this.render();
  }

  render(): void {
    if (!this.stockForecast) {
      this.container.innerHTML = this.DELIVERY_DATE_UNKNOWN_ICON;
      return;
    }

    if (this.stockForecast.length === 1) {
      this.container.innerHTML = this.DELIVERY_DATE_KNOWN_ICON;
      return;
    }

    if (this.stockForecast.length > 1) {
      this.container.innerHTML = this.PARTIAL_DELIVERY_ICON;
      return;
    }

    this.container.innerHTML = this.DELIVERY_DATE_UNKNOWN_ICON;
  }
}
